<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.user_address"
        placeholder="用户地址"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.order_no"
        placeholder="订单号"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.plan_id"
        placeholder="套餐"
        clearable
        size="small"
        class="filter-item"
        style="width: 200px"
      >
        <el-option
          v-for="plan in planOptions"
          :key="plan.id"
          :label="plan.name"
          :value="plan.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        size="small"
        class="filter-item"
        style="width: 180px"
      >
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input
        v-model="listQuery.tx_hash"
        placeholder="交易哈希"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        size="small"
        type="success"
        icon="el-icon-present"
        @click="openGiftDialog"
        >赠送套餐</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
    >
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column label="订单号" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>
      <el-table-column label="套餐" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.nft_plan?.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="价格" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column label="用户地址" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.user_address }}
        </template>
      </el-table-column>
      <el-table-column label="付款地址" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.payer_address || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusMap[scope.row.status]?.type || 'info'" size="mini">
            {{ statusMap[scope.row.status]?.label || scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="交易哈希" min-width="220">
        <template slot-scope="scope">
          <span v-if="scope.row.tx_hash">{{ scope.row.tx_hash }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_method || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="170" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="赠送节点套餐"
      :visible.sync="giftDialogVisible"
      width="500px"
      @closed="resetGiftForm"
    >
      <el-form :model="giftForm" label-width="100px">
        <el-form-item label="用户地址">
          <el-input
            v-model="giftForm.user_addresses"
            type="textarea"
            :rows="5"
            placeholder="请输入用户地址，多个地址请换行分隔"
          />
        </el-form-item>
        <el-form-item label="套餐">
          <el-select v-model="giftForm.plan_id" placeholder="请选择套餐">
            <el-option
              v-for="plan in planOptions"
              :key="plan.id"
              :label="`${plan.name} (Lv.${plan.level})`"
              :value="plan.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number
            v-model="giftForm.quantity"
            :min="1"
            :max="100"
            controls-position="right"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="giftDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="giftLoading" @click="submitGift">
          确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

const emptyGiftForm = () => ({
  user_addresses: "",
  plan_id: null,
  quantity: 1,
});

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_address: "",
        order_no: "",
        plan_id: "",
        status: "",
        tx_hash: "",
      },
      statusOptions: [
        { label: "待付款", value: "pending" },
        { label: "已付款", value: "paied" },
        { label: "已完成", value: "completed" },
      ],
      statusMap: {
        pending: { label: "待付款", type: "info" },
        paied: { label: "已付款", type: "warning" },
        completed: { label: "已完成", type: "success" },
      },
      planOptions: [],
      giftDialogVisible: false,
      giftForm: emptyGiftForm(),
      giftLoading: false,
    };
  },
  created() {
    this.getList();
    this.fetchPlanOptions();
  },
  methods: {
    getList() {
      this.listLoading = true;
      const params = { ...this.listQuery };
      Object.keys(params).forEach((key) => {
        if (
          params[key] === "" ||
          params[key] === null ||
          params[key] === undefined
        ) {
          delete params[key];
        }
      });
      request({
        url: "/api/admin/nft-plan/orders",
        method: "get",
        params,
      })
        .then((res) => {
          this.list = res.data?.data || [];
          this.total = res.data?.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    fetchPlanOptions() {
      request({
        url: "/api/admin/nft-plan/list",
        method: "get",
        params: {
          page: 1,
          limit: 100,
        },
      }).then((res) => {
        this.planOptions = res.data?.data || [];
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    openGiftDialog() {
      this.giftDialogVisible = true;
    },
    resetGiftForm() {
      this.giftForm = emptyGiftForm();
      this.giftLoading = false;
    },
    submitGift() {
      const addresses = (this.giftForm.user_addresses || '')
        .split(/\r?\n/)
        .map(addr => addr.trim())
        .filter(addr => !!addr);
      if (addresses.length === 0) {
        this.$message.error("请输入用户地址");
        return;
      }
      if (!this.giftForm.plan_id) {
        this.$message.error("请选择套餐");
        return;
      }
      this.giftLoading = true;
      request({
        url: "/api/admin/nft-plan/gift",
        method: "post",
        data: {
          user_addresses: this.giftForm.user_addresses.trim(),
          plan_id: this.giftForm.plan_id,
          quantity: this.giftForm.quantity,
        },
      })
        .then(() => {
          this.$message.success("赠送成功");
          this.giftDialogVisible = false;
          this.getList();
        })
        .finally(() => {
          this.giftLoading = false;
        });
    },
  },
};
</script>
